import { z } from 'zod'

// Regex patterns
const PHONE_REGEX = /^\+38\s0\d{2}\s\d{3}\s\d{2}\s\d{2}$/

// Error messages by locale
const ERROR_MESSAGES = {
  uk: {
    required: "Обов'язкове поле",
    fullNameMin: 'Мінімум 3 символи',
    phone: 'Формат: +38 0XX XXX XX XX',
    selectOption: 'Оберіть варіант',
  },
  en: {
    required: 'Required field',
    fullNameMin: 'Minimum 3 characters',
    phone: 'Format: +38 0XX XXX XX XX',
    selectOption: 'Select option',
  },
}

// Civil form validation schema factory
export const createCivilFormSchema = (locale: 'uk' | 'en' = 'uk') => {
  const msg = ERROR_MESSAGES[locale]

  return z.object({
    fullName: z.string().min(3, msg.fullNameMin),
    age: z.number().optional(),
    phone: z.string().min(1, msg.required).regex(PHONE_REGEX, msg.phone),
    position: z.string().min(1, msg.required),
    hobbies: z.string().optional(),
  })
}

// Default schema for backward compatibility
export const civilFormSchema = createCivilFormSchema('uk')

// Military form validation schema factory
export const createMilitaryFormSchema = (locale: 'uk' | 'en' = 'uk') => {
  const msg = ERROR_MESSAGES[locale]

  return z.object({
    position: z.string().min(1, msg.required),
    fullName: z.string().min(3, msg.fullNameMin),
    age: z.number().optional(),
    militaryRank: z.string().min(1, msg.required),
    bzpvCompleted: z
      .enum(['yes', 'no'], { message: msg.selectOption })
      .refine((val) => val === 'yes' || val === 'no', {
        message: msg.selectOption,
      }),
    szcStatus: z
      .enum(['yes', 'no'], { message: msg.selectOption })
      .refine((val) => val === 'yes' || val === 'no', {
        message: msg.selectOption,
      }),
    phone: z.string().min(1, msg.required).regex(PHONE_REGEX, msg.phone),
  })
}

// Default schema for backward compatibility
export const militaryFormSchema = createMilitaryFormSchema('uk')

export type CivilFormSchema = z.infer<typeof civilFormSchema>
export type MilitaryFormSchema = z.infer<typeof militaryFormSchema>
